module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.couriers,
      "hide-actions": "",
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.phone))]), _vm._v(" "), _c('td', [_c('v-icon', {
          attrs: {
            "color": props.item.online ? 'green' : 'grey'
          }
        }, [_vm._v("lens")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.last_login)))]), _vm._v(" "), _c('td', {
          staticClass: "justify-end layout px-0"
        })]
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_vm._v("\n      učitavanje...\n    ")])], 2)], 1)
},staticRenderFns: []}